import React, { Component } from "react";
import PropTypes from "prop-types";
import axiosClient from "../common/axios_client";

class NotificationMessenger extends Component  {
  constructor(props) {
    super(props);

    this.state = {
      settingState: Boolean(props.settings.message_messenger)
    };
  }

  handleSettingButtonClick = (event) => {
    axiosClient.patch("/api/v1/user/notification_settings/message_messenger/notice",
      {
        notification_setting: {
          notice: event.target.childNodes[0].value
        }
      })
      .then(settings => {
        this.setState({
          settingState: settings.data.message_messenger
        });
      })
      .catch();
  };

  render () {
    const { settingState } = this.state;

    return (
      <div className='col-3 col-md-2 text-center btn-notify-setting'>
        <div className='mb-1'>Messenger</div>
        <div className='btn-group btn-group-toggle' data-toggle='buttons'>
          <label
            className={`btn btn-outline-primary ${settingState ? "active" : ""}`}
            htmlFor='message_messenger_on'
            onClick={this.handleSettingButtonClick}
          >
            <input
              id='message_messenger_on'
              type='radio'
              value='on'
              defaultChecked={settingState}
            />
            {" "}
ON
          </label>
          <label
            className={`btn btn-outline-primary ${!settingState ? "active" : ""}`}
            htmlFor='message_messenger_off'
            onClick={this.handleSettingButtonClick}
          >
            <input
              id='message_messenger_off'
              type='radio'
              value='off'
              defaultChecked={!settingState}
            />
            {" "}
OFF
          </label>
        </div>
      </div>
    );
  }
}

NotificationMessenger.propTypes = {
  settings: PropTypes.shape({
    message_messenger: PropTypes.bool
  }).isRequired
};

export default NotificationMessenger;
